import { useEffect, useMemo, useState } from 'react';
import '/assets/styles/pages/menu.scss';

// Sections
import MenuHeader from '/views/sections/menu-header';

// Partials
import CategoryCard from '/views/partials/category-card';

// Services
import menuServices from '/services/menu';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';

const Menu = () => {
	const { selectedBranch, initialized } = useBranchSelection();
	const { openModal } = useModals();
	const { redirect } = useNavigator();
	const [rawCategories, setCategories] = useState(null);

	const categories = useMemo(() => rawCategories ?? [false, false, false, false, false, false, false, false, false], [rawCategories]);

	useEffect(() => {
		setCategories(null);
		if (selectedBranch) {
			menuServices
				.getMenuCategories(selectedBranch?.slug)
				.then((payload) => {
					setCategories(payload);
				})
				.catch((feedback) => {
					redirect('open');
					openModal('message', { feedback });
				});
		} else if (initialized) {
			redirect('home');
		}
	}, [selectedBranch, initialized]);

	return (
		<>
			<MenuHeader />
			<div className="menu-container loader-container">
				{categories && (
					<div className="menu-categories wrapper">
						<ul className="categories-list">
							{categories.map((category, nth) => (
								<li className="list-item" key={category?.id ?? nth}>
									<CategoryCard className="list-category" category={category} />
								</li>
							))}
						</ul>
					</div>
				)}
			</div>
			<div className="menu-decoration"></div>
		</>
	);
};

export default Menu;
